<app-slide
  [mechanicalDisplacement]="!isMobile"
  [activated]="!!tiles?.length"
  [quantityOfItems]="tiles?.length"
  [slideWidth]="slideWidth">
  <ng-container *ngFor="let tile of tiles; index as id">
    <div
      #slideTitle
      class="slideTile__content-item"
      [style.width]="slideWidth + 'px'">
      <div
        class="slideTile__image-item"
        [id]="'slide-title-item-' | uniqueId: getIdentificator(id)"
        (click)="selectTile(tile)">
        <app-image
          [src]="tile.image_url"
          [type]="typeImageFlight"
          [borderRadius]="12">
        </app-image>
        <div class="slideTile__text-image">
          <app-ds-typography
            [size]="fontSize.XXXS"
            [fontFamily]="fontFamily.Regular"
            [color]="fontColor.Invert"
            [text]="tile.title">
          </app-ds-typography>
        </div>
      </div>
    </div>
  </ng-container>
</app-slide>
